export const ELASTIC_ENDPOINT = 'https://search.mycryptoapi.com/';
